import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Collapse, TableCell, TableRow, Chip } from "@material-ui/core";
import "react-datetime/css/react-datetime.css";

import Dialog from "../dialog";
import TableFormat from "../../partials/TableFormat";
import Loading from "../loading";
import Snackbar from "../snackbar";
import { _parsePhoneNumber } from "../../partials/validateNumber";
import Detail from "./detail";
import { styles } from "./styles";
import Header from "../../partials/header";
import { formatDatetime } from "../../utils/setting";

const headCells = [
  { key: "firstName", numeric: false, disablePadding: true, label: "name" },
  { key: "spa", numeric: false, disablePadding: true, label: "module_mySpa" },
  {
    key: "createdAt",
    numeric: false,
    disablePadding: false,
    label: "service_account_createdAt",
  },
  {
    key: "active",
    numeric: false,
    disablePadding: false,
    label: "service_account_status",
  },
  {
    key: "role",
    numeric: false,
    disablePadding: false,
    label: "service_account_role",
  },
  { key: "action", numeric: false, disablePadding: false, label: "action" },
];

class ListCampaign extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      orderBy: "firstName",
      selected: [],
      index: 0,
      dialog: {
        messageConfirm: "",
        content: "",
      },
    };
  }
  componentDidMount() {
    this.getList();
  }
  getList = async (payload = {}) => {
    this.loading.startLoading();
    let check = await this.props.getList({
      limit: this.state.rowsPerPage,
      page: this.state.page,
      ...payload,
    });
    this.loading.stopLoading();
    if (check.code !== 1) this.mSnackbar.handleClick(check.message);
  };
  updateStatusUser = async (payload) => {
    this.loading.startLoading();
    let check = await this.props.updateStatusUser(payload);
    this.loading.stopLoading();
    if (check.code !== 1) this.mSnackbar.handleClick(check.message);
    else if (check.code === 1) {
      this.handleOpenCollapes(-1);
      this.getList();
    }
  };
  handleOpenCollapes = (id) => {
    const { allUser = [] } = this.props;
    let { collapse = [] } = this.state;
    for (var i = 0; i <= allUser.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else {
        collapse[i] = false;
      }
    }
    this.setState({ collapse: collapse });
  };

  renderCollapse = (row, index) => {
    const { classes, allUser = [], listService = [] } = this.props;
    const { collapse = [] } = this.state;
    return (
      <TableRow key={index} className={classes.tableRowHeight}>
        <TableCell
          colSpan={headCells.length}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <Detail
              data={allUser[index]}
              spa={listService.find(
                (e) => e.userCode === allUser[index].userCode
              )}
              updateStatusUser={this.updateStatusUser}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  actionColumn = (row = {}, index) => {
    const { listService = [] } = this.props;
    let spa = listService.find((e) => e.userCode === row.userCode) || {};
    const { t } = this.props;
    return (
      <div>
        {spa && spa.no ? (
          <Link
            to={{
              pathname: `/service-admin/detail`,
              search: `?serviceCode=${spa.no}`,
              state: {
                fromListUser: true,
              },
            }}
          >
            <Button variant="outlined">{t("go_to_spa")}</Button>
          </Link>
        ) : (
          ""
        )}
      </div>
    );
  };

  render() {
    const {
      classes,
      t,
      total,
      count,
      allUser = [],
      allOwnerRole = [],
      listService = [],
    } = this.props;
    const { collapse = [], dialog = {}, orderBy, order } = this.state;
    return (
      <React.Fragment className={classes.root}>
        <Dialog
          onRef={(dialog) => (this.mDialog = dialog)}
          disagree={t("membercard_list_cancel")}
          agree={dialog.messageConfirm}
          title={t("membercard_list_notice")}
          content={dialog.content}
          action={this.actionDialog}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Header session={t("sidebar_superadmin")} title={t("list_users")} />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          orderBy={orderBy}
          order={order}
          contentDialog={false}
          onDelete={false}
          title={t("list_users")}
          showFilter={false}
          showActionToolbar={false}
          showCheckBox={false}
          placeholder={t("users_search_by_name_phone")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          collapse={collapse}
          isCollapse={true}
          actionColumn={this.actionColumn}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getList}
          rows={allUser.map((row, index) => {
            let validPhone = _parsePhoneNumber(row.countryCode, row.username)
              .format_internal;
            let name = `${row.firstName} ${row.lastName}`;
            let spa = listService.find((e) => e.userCode === row.userCode);
            return {
              id: row.id,
              firstName: (
                <>
                  <p>{name.trim()}</p>
                  <p>{validPhone}</p>
                </>
              ),
              userCode: row.userCode,
              spa: spa && spa.name ? spa.name : "",
              createdAt: (
                <>
                  <p>{formatDatetime(row.createdAt)}</p>
                  <p>{formatDatetime(row.updatedAt)}</p>
                </>
              ),
              active: (
                <>
                  {row.active ? (
                    <Chip
                      label={t("employees_listemployee_active")}
                      className={classes.activeChip}
                    />
                  ) : (
                    <Chip label={t("employees_listemployee_inactive")} />
                  )}
                </>
              ),
              role: (
                <>
                  {allOwnerRole.find((ele) => ele === row.userCode) ? (
                    <Chip
                      label={t("ownerSpa")}
                      className={classes.activeChip}
                    />
                  ) : (
                    <Chip label={t("user")} />
                  )}
                </>
              ),
            };
          })}
        />
      </React.Fragment>
    );
  }
}

ListCampaign.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  total: state.user.total,
  count: state.user.count,
  allUser: state.user.allUser,
  allOwnerRole: state.user.allOwnerRole,
  listService: state.service.serviceList,
});

const mapDispatch = (dispatch) => ({
  getList: dispatch.user.getAllUser,
  updateStatusUser: dispatch.user.updateStatusUser,
});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ListCampaign)
  )
);
